/**
 * Export Button Component
 *
 * Button to export view data to CSV.
 * Based on original MyVault ExportButton.tsx patterns.
 */

import React from "react";
import { Button, Menu, MenuItem, ListItemDecorator } from "@mui/joy";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useExportViewMutation } from "../../hooks/useViewDataQuery";

interface ExportButtonProps {
  viewId: string;
  disabled?: boolean;
}

export default function ExportButton({
  viewId,
  disabled = false,
}: ExportButtonProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const exportMutation = useExportViewMutation();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExport = (format: "csv" | "excel") => {
    exportMutation.mutate({ viewId, filters: undefined });
    handleClose();
  };

  return (
    <>
      <Button
        variant="outlined"
        color="neutral"
        size="sm"
        startDecorator={<FileDownloadIcon />}
        onClick={handleClick}
        disabled={disabled || exportMutation.isPending}
        loading={exportMutation.isPending}
      >
        Export
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        placement="bottom-end"
      >
        <MenuItem onClick={() => handleExport("csv")}>
          <ListItemDecorator>
            <FileDownloadIcon />
          </ListItemDecorator>
          Export as CSV
        </MenuItem>
      </Menu>
    </>
  );
}
